import { render } from "./BomValidationResultsElementsUnused.vue?vue&type=template&id=28ea36d6&scoped=true"
import script from "./BomValidationResultsElementsUnused.vue?vue&type=script&lang=js"
export * from "./BomValidationResultsElementsUnused.vue?vue&type=script&lang=js"

import "./BomValidationResultsElementsUnused.vue?vue&type=style&index=0&id=28ea36d6&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ea36d6"]])

export default __exports__
import QVirtualScroll from 'quasar/src/components/virtual-scroll/QVirtualScroll.js';
import QExpansionItem from 'quasar/src/components/expansion-item/QExpansionItem.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QVirtualScroll,QExpansionItem});
